var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"main-wrapper"}},[(_vm.staticHeaderList.includes(_vm.$route.name))?_c('StaticHeader'):(_vm.$route.name == 'Homepage')?_c('LandingpageHeader',{attrs:{"id":"hideinmobile"}}):(_vm.isAuthenticated || _vm.isPublicProfile)?_c('Header'):_c('GuestHeader'),_c('NoSideBarMain')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }